import React from 'react';
import { FieldProps } from 'formik';
import { DatePicker } from '../ui/DatePicker';
import { cn } from '../../utils/cn';

interface DatePickerFieldOwnProps {
  label?: string;
  disabled?: boolean;
  placeholder?: string;
  className?: string;
  required?: boolean;
  onChange?: (date: Date | undefined) => void;
}

type DatePickerFieldProps = FieldProps & DatePickerFieldOwnProps;

export const DatePickerField: React.FC<DatePickerFieldProps> = ({
  field,
  form: { touched, errors, setFieldValue },
  label,
  disabled,
  placeholder,
  className,
  required,
  onChange,
}) => {
  const hasError = touched[field.name] && !!errors[field.name];
  const errorMsg = hasError ? (errors[field.name] as string) : null;

  const handleChange = (date: Date | undefined) => {
    if (onChange) {
      onChange(date);
    } else {
      setFieldValue(field.name, date);
    }
  };

  // Convert field.value to Date if it's a string
  const dateValue = field.value
    ? field.value instanceof Date
      ? field.value
      : new Date(field.value)
    : null;

  return (
    <div className={cn('flex flex-col gap-1', className)}>
      {label && (
        <label htmlFor={field.name} className="text-sm font-medium text-neutral-700">
          {label}
          {required && <span className="text-destructive ml-0.5">*</span>}
        </label>
      )}
      <DatePicker
        data-testid={`datepicker-field-${field.name}`}
        value={dateValue}
        onChange={handleChange}
        disabled={disabled}
        placeholder={placeholder}
      />
      {hasError && <span className="text-destructive text-xs">{errorMsg}</span>}
    </div>
  );
};
